import { GetSocietePourUnUtilisateurDto } from "@lexi-clients/lexi";

export class Societe {
  id: number;
  intitule: string;
  enabled: boolean;
  gestionStock: boolean;
  fretLocalActif: boolean;
  classificationComptableTypeId: number;
  classificationSavTypeId: number;
  classificationComptableTypeIntitule: string;
  boAutoInsert: boolean;
  boIntitule: string;
  avecBackOffice: boolean;

  constructor(init?: Partial<GetSocietePourUnUtilisateurDto>) {
    Object.assign(this, init);
    this.avecBackOffice = !!init?.boIntitule;
  }
}
